import { useEffect, useState } from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

const Checkbox = ({ className, disabled, label, onChange, value = false }) => {
  const [isChecked, setIsChecked] = useState(value);
  const key = `${+new Date()}${Math.floor(Math.random() * 100)}`;

  const handleChecked = (value) => {
    setIsChecked(value);
    onChange?.(value);
  };

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  return (
    <div className={cn('flex gap-2 items-center', className)}>
      <CheckboxPrimitive.Root
        checked={isChecked}
        className={cn(
          'border h-4 w-4 rounded-sm',
          disabled && 'cursor-not-allowed'
        )}
        disabled={disabled}
        id={key}
        onCheckedChange={handleChecked}
        value={isChecked}
      >
        <CheckboxPrimitive.Indicator>
          <CheckIcon className="h-full w-full" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label
        className={cn(
          'select-none',
          disabled && 'text-gray-400',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
        htmlFor={key}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
